module.exports = __webpack_public_path__ + "static/media/0269_Medium.78f75363.jpg";